import { IOrderClosingProtectionLetterData } from 'types/order/documents/IOrderClosingProtectionLetterData';
import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';
import { IOrderClosingProtectionLetterResponse } from 'types/order/documents/IOrderClosingProtectionLetterResponse';
import { IClosingProtectionLetterResponse } from 'types/order/documents/IClosingProtectionLetterResponse';
import { IClosingProtectionLetterData } from 'types/order/documents/IClosingProtectionLetterData';
import { baseUrlService } from '../../../ui-toolkit/rest/BaseUrlService';

const convertClosingProtectionLetterResponseToData = ({
  amount_cents,
  id,
}: IClosingProtectionLetterResponse): IClosingProtectionLetterData => ({
  id,
  amountCents: amount_cents,
});

const convertOrderClosingProtectionLetterResponseToData = ({
  borrower_cpl,
  borrowers_names,
  buyer_cpl,
  lender,
  lender_cpl,
  order_id,
  seller_cpl,
  underwriter,
}: IOrderClosingProtectionLetterResponse): IOrderClosingProtectionLetterData => ({
  lender,
  underwriter,
  borrowerCPL: borrower_cpl ? convertClosingProtectionLetterResponseToData(borrower_cpl) : undefined,
  borrowersNames: borrowers_names,
  buyerCPL: buyer_cpl ? convertClosingProtectionLetterResponseToData(buyer_cpl) : undefined,
  lenderCPL: lender_cpl ? convertClosingProtectionLetterResponseToData(lender_cpl) : undefined,
  orderId: order_id,
  sellerCPL: seller_cpl ? convertClosingProtectionLetterResponseToData(seller_cpl) : undefined,
});

export const getOrderClosingProtectionLetterDataAsync = async (
  orderId: string
): Promise<IOrderClosingProtectionLetterData> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<IOrderClosingProtectionLetterResponse>(`/orders/v5/admin/${orderId}/cpl`)
    .then((response) => convertOrderClosingProtectionLetterResponseToData(response.data))
    .catch(axiosErrorHandler);
